import * as React from "react";
import { ErrorScreen } from "@stenajs-webui/panels";
import { ActivateHeadAgreementFetcher } from "./ActivateHeadAgreementFetcher";
import { useParams } from "react-router";
import { Helmet } from "react-helmet";

interface Props {}

export const ActivateHeadAgreementScreen: React.FC<Props> = () => {
  const { headAgreementId, customerId } = useParams() as {
    headAgreementId: string;
    customerId: string;
  };
  if (!headAgreementId) {
    return <ErrorScreen text={"Missing headAgreementId."} />;
  }

  return (
    <>
      <Helmet title="Activate HA - Customer - FPP" />
      <ActivateHeadAgreementFetcher
        headAgreementId={headAgreementId}
        customerId={customerId}
      />
    </>
  );
};
